export default __webpack_public_path__ + "static/8-1--53df65114c9265042bbb5b8e8f43981c.png";